var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40174 0.156101C5.79607 -0.0520334 8.20393 -0.0520336 10.5983 0.1561L11.7518 0.256377C12.5197 0.323132 13.1774 0.781175 13.5182 1.43637C13.5618 1.52019 13.5291 1.62167 13.4488 1.6714L8.66271 4.63423C7.63622 5.26967 6.34191 5.283 5.30255 4.66884L0.484464 1.82179C0.406622 1.77579 0.370892 1.68111 0.405973 1.59777C0.717734 0.857191 1.41865 0.328487 2.24819 0.256377L3.40174 0.156101Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.402052 3.10391C0.282923 3.03352 0.130919 3.10927 0.117032 3.24695C-0.0767776 5.16846 -0.0298702 7.10816 0.257755 9.02086C0.409385 10.0292 1.23234 10.8022 2.24819 10.8905L3.40174 10.9908C5.79606 11.1989 8.20394 11.1989 10.5983 10.9908L11.7518 10.8905C12.7677 10.8022 13.5906 10.0292 13.7422 9.02086C14.0383 7.05242 14.0793 5.05538 13.8654 3.07901C13.8504 2.94036 13.6958 2.866 13.5772 2.93941L9.26577 5.60841C7.877 6.46813 6.12587 6.48617 4.71968 5.65524L0.402052 3.10391Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemNotificationIcon);
export default __webpack_public_path__ + "static/media/SystemNotificationIcon.2d66110b6490a3ed519d5ac89d906a52.svg";
export { ForwardRef as ReactComponent };